export default "__VITE_ASSET__w4xkqDU2__"